import { usersAvatarsCellFactory } from '@core/account-ui';
import { injectTranslate } from '@core/i18n-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../offer-columns';

export const followersColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Followers,
  label: injectTranslate()('app.offers.table.followers'),
  visible: false,
  geometry: {
    width: 120,
    minWidth: 120,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: usersAvatarsCellFactory('followers'),
}));
